import React from 'react'
import ContentCard from "../../components/content-blocks/ContentCard"
import SimpleSlider from './SimpleSlider'
import StoryContentCard from '../content-blocks/StoryContentCard'
import EventContentCard from '../content-blocks/EventContentCard'

const SimpleSliderItems = ({ items, size, type, infinite=false }) => {
    let myItems = []
    let idx = 0
    items.forEach((item) => {
        const cardImg = (item?.featuredImage?.node?.localFile) ? item.featuredImage.node.localFile : null
        const title = item?.title ?? ''
        switch (type) {
          case 'news': 
            myItems.push(
              <StoryContentCard key={title} size={size} img={cardImg} {...item} />
            )
            break
          case 'event':
            const adjSize = (idx === 0) ? 'L' : size
            myItems.push(
              <EventContentCard key={title} size={adjSize} img={cardImg} {...item} />
            )
            break
          default: 
            myItems.push(
              <ContentCard key={title} size={size} img={cardImg} {...item} />
            )
            break
        }
        idx++
      })
    myItems = myItems.filter(function( element ) {
        return element !== undefined;
    })
  

    return (
        <SimpleSlider 
            slidesToShow={2}
            infinite={infinite}
            variableWidth
            slidesToScroll={2}
          >{myItems}
        </SimpleSlider>
    )
}
export default SimpleSliderItems
